






























































































































































































































































































import { Component } from 'vue-mixin-decorator';
import { Watch } from 'vue-property-decorator';

import MarkdownToHTML from '@/common/MarkdownToHTML';
import BaseView from '@/views/BaseView.vue';
import ExamFooter from '@/components/ExamFooter.vue';
import ExamGuide from '@/components/ExamGuide.vue';
import ExamNav from '@/components/ExamNav.vue';
import ExamAudio from '@/components/ExamAudio.vue';
import RadarChart from '@/components/RadarChart.vue';
import IndicatorModal from '@/components/IndicatorModal.vue';
import ExamResultRankScoreLevel from '@/components/ExamResultRankScoreLevel.vue';

import ExamResultModelAnswer from '@/views/exam/result/ExamResultModelAnswer.vue';

import * as StringUtil from '@/common/StringUtil';

import * as DesignCode from '@/classification/DesignCode';

import RepositoryFactory from '@/repository/RepositoryFactory';

import ExamInfo from '@/models/exam/ExamInfo';
import DesignResource from '@/models/exam/DesignResource';
import BenefitsDetail from '@/models/benefits/BenefitsDetail';
import Rank from '@/models/rank/Rank';
import Evaluation from '@/models/evaluation/Evaluation';
import ScoreLevel from '@/models/exam/ScoreLevel';
import moment from 'moment';
import Benefit from '@/models/benefits/Benefit';

@Component(
  {
    components: {
      'e-footer': ExamFooter,
      'e-guide': ExamGuide,
      'e-nav': ExamNav,
      'e-radar-chart': RadarChart,
      'e-indicator': IndicatorModal,
      'e-score-level': ExamResultRankScoreLevel,
      'e-audio': ExamAudio,
      'e-model-answer': ExamResultModelAnswer,
    },
  },
)
export default class ExamResult extends BaseView {
  private examInfo: ExamInfo = new ExamInfo();

  private resultRankCode = '';

  private entryCode = '';

  private resultCode = '';

  private rankTitle = '';

  private otherRanks: Rank[] = [];

  private benefits: Benefit[] = [];

  private topBenefitsDetails: BenefitsDetail[] = [];

  private resultShareUri = '';

  private shareResultText = '';

  private twitterShareUri = '';

  private result: any = null;

  private isShowModelAnswers = false;

  private categories = null;

  private evaluations: Evaluation[] = [];

  private scoreLevel: ScoreLevel = new ScoreLevel();

  private videoWidth = '100%';

  private isIndicatorDisplay = false;

  private isDisplayRetest = false;

  private childTab: Window | null = null;

  $refs!: {
    examNav: ExamNav;
  }

  private twitterShareResultText = '';

  private resources = {
    ENTRY_ICON: new DesignResource(),
    BENEFITS_ICON: new DesignResource(),
    RANK_BENEFIT_THUMBNAIL: new DesignResource(),
    RESULT_BENEFITS_BG: new DesignResource(),
    RESULT_BENEFITS_MAIN_COLOR: new DesignResource(),
    RESULT_BENEFITS_SUB_TITLE_COLOR: new DesignResource(),
    BENEFITS_BADGE_ALL: new DesignResource(),
    BENEFITS_BADGE_PASS: new DesignResource(),
    BENEFITS_BADGE_PERFECT: new DesignResource(),
    EXAM_RANK_ICON: new DesignResource(),
    TOP_ENTRY_MAIN_COLOR: new DesignResource(),
    EXAM_RETRY_IMG: new DesignResource(),
    CHART_TITLE: new DesignResource(),
    PASS_DISPLAY_COMMENT: new DesignResource(),
    PASS_DISPLAY_IMG: new DesignResource(),
    FAIL_DISPLAY_COMMENT: new DesignResource(),
    FAIL_DISPLAY_IMG: new DesignResource(),
    GOODS_APPEAL_IMG: new DesignResource(),
    ANSWER_RATE_RESULT_BG: new DesignResource(),
    CHART_TITLE_CATEGORY_BG: new DesignResource(),
    CHART_TITLE_EVALUATION_BG: new DesignResource(),
    TWITTER_SHARE_RESULT: new DesignResource(),
    RESULT_SCORE_LEVEL: new DesignResource(),
    HIDE_PASS_BENEFIT_WHEN_PERFECT: new DesignResource(),
  };

  private async mounted() {
    const { entry, result } = this.$route.query;
    if (entry === undefined || result === undefined) {
      this.$router.replace(this.paths.TOP);
    }
    this.entryCode = String(entry);
    this.resultCode = String(result);

    this.initStaticScripts();

    this.isIndicatorDisplay = true;

    // 検定情報を取得する
    const ExamRepository = RepositoryFactory.get().exam;
    await ExamRepository.getExam().then((response: any) => {
      if (response.status !== 200) {
        return;
      }
      // eslint-disable-next-line prefer-destructuring
      const data = response.data;
      this.examInfo.examTitle = data.exam_title;
      this.examInfo.inPeriod = data.in_period;
      // デザインリソース
      if (data.resources === undefined) {
        return;
      }
      const rankOnlyDesignResource = [DesignCode.HIDE_PASS_BENEFIT_WHEN_PERFECT];
      data.resources.forEach((resource: any) => {
        const key = resource.display_place_key;
        if (rankOnlyDesignResource.includes(key)) {
          return;
        }
        if (key in this.resources) {
          const tmp = new DesignResource();
          tmp.displayPlaceKey = resource.display_place_key;
          tmp.displayText = StringUtil.isEmpty(resource.display_text) ? '' : resource.display_text;
          tmp.cssClassName = StringUtil.isEmpty(resource.css_class_name) ? '' : resource.css_class_name;
          tmp.resourceUri = StringUtil.isEmpty(resource.resource_uri) ? '' : resource.resource_uri;
          tmp.resourceFileName = StringUtil.isEmpty(resource.resource_file_name) ? '' : resource.resource_file_name;
          tmp.alternativeText = StringUtil.isEmpty(resource.alternative_text) ? '' : resource.alternative_text;
          // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
          // @ts-ignore
          this.resources[key] = tmp;
        }
      });
    });

    // 受験結果を取得
    const EntryRepository = RepositoryFactory.get().entry;
    await EntryRepository.getResult(this.entryCode, this.resultCode).then((response: any) => {
      if (response.status !== 200) {
        return;
      }
      this.result = response.data;
      if (this.result === null) {
        return;
      }
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      this.categories = this.result.categories;

      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      this.resultRankCode = this.result.exam_rank_code;

      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      this.result.evaluations.forEach((evaluation: any) => {
        const eva = new Evaluation();
        eva.evaluationCode = evaluation.evaluation_code;
        eva.evaluationTitle = evaluation.evaluation_title;
        eva.correctRate = evaluation.correct_rate;
        this.evaluations.push(eva);
      });

      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      const scoreLevel = this.result.score_level as any;
      if (!scoreLevel) {
        return;
      }
      const sl = new ScoreLevel();
      sl.name = scoreLevel.name;
      sl.explanation = scoreLevel.explanation;
      sl.notes = scoreLevel.notes;
      sl.threshold = scoreLevel.threshold;
      sl.isShareTarget = scoreLevel.is_share_target;
      sl.isPositionResultTop = scoreLevel.is_position_result_top;
      if (scoreLevel.score_level_resource) {
        sl.resourceUri = scoreLevel.score_level_resource.resource_uri;
        sl.resourceFileName = scoreLevel.score_level_resource.resource_file_name;
        sl.alternativeText = scoreLevel.score_level_resource.alternative_text;
        if (sl.isShareTarget) {
          const ext = ExamResult.getExt(scoreLevel.score_level_resource.resource_uri);
          this.setResultShareUri(scoreLevel.score_level_resource.resource_uri.replace(`.${ext}`, '.html'));
        }
      }
      this.scoreLevel = sl;
    }).catch(() => {
      this.$router.replace(this.paths.TOP);
    });

    // 獲得特典の取得
    await EntryRepository.getBenefits(this.entryCode, this.resultCode).then((response: any) => {
      if (response.status !== 200 || response.data.benefits === undefined) {
        return;
      }
      const benefits = EntryRepository.convert.deserialize(response.data.benefits, Benefit) as Benefit[];
      benefits.forEach((benefit) => {
        const b = benefit;
        b.explanation = MarkdownToHTML(b.explanation);
        b.notes = MarkdownToHTML(b.notes);
        b.details.forEach((detail) => {
          if (detail.isShareTarget && detail.benefitsResource !== undefined && detail.benefitsResource.resourceUri !== undefined) {
            const ext = ExamResult.getExt(detail.benefitsResource.resourceUri);
            this.setResultShareUri(detail.benefitsResource.resourceUri.replace(`.${ext}`, '.html'));
          }
          if (detail.isPositionResultTop) {
            this.topBenefitsDetails.push(detail);
          }
        });
      });
      this.benefits = benefits.filter((v) => v.displayType !== 'none');
    }).catch(() => {
      this.$router.replace(this.paths.TOP);
    });

    // 検定ランク情報の初期化とランクリソースの取得
    await this.initRankInfo();
    this.executeBenefitsFilter();

    // その他の検定ランクを取得する
    const RankRepository = RepositoryFactory.get().rank;
    await RankRepository.getRanks().then((response: any) => {
      if (response.status !== 200 || response.data.exam_ranks === undefined) {
        return;
      }
      response.data.exam_ranks.forEach((rank: any) => {
        const rankObj = new Rank();
        rankObj.rankCode = StringUtil.encodeToBase64Url(rank.exam_rank_code);
        rankObj.title = rank.exam_rank_title;
        if (rank.fees.length > 0) {
          rankObj.fee = StringUtil.separateNumber(rank.fees[0].fee);
        } else {
          rankObj.fee = '0';
        }
        rankObj.paymentType = rank.exam_fee_type;

        // eslint-disable-next-line prefer-destructuring
        const resources = rank.resources;
        if (resources !== undefined && resources.length > 0) {
          resources.forEach((resource: any) => {
            if (resource.display_place_key === DesignCode.EXAM_RANK_ICON) {
              rankObj.thumbnail = resource.resource_uri;
              rankObj.alternativeText = resource.alternative_text;
            }
          });
        }

        // 受験したランクは表示しない
        if (this.resultRankCode === rank.exam_rank_code) {
          return;
        }
        this.otherRanks.push(rankObj);
      });
    });

    this.isIndicatorDisplay = false;
  }

  executeBenefitsFilter() {
    // 「満点時合格非表示」設定の処理
    if (this.resources.HIDE_PASS_BENEFIT_WHEN_PERFECT.displayText === '1' && this.result.correct_rate === 100) {
      this.benefits = this.benefits.filter((v) => v.benefitsType !== 'pass');
    }
  }

  /**
   * 検定詳細画面に遷移します。
   *
   * @param rankCode（Base64エンコードされたコード）
   */
  private transitionExamDetail(rankCode: string) {
    this.$router.replace(`${this.paths.KENTEI_DETAIL}?rank=${rankCode}`);
  }

  /**
   * 静的CssとJsの読み込み
   */
  private initStaticScripts() {
    const CommonCss = document.createElement('link');
    CommonCss.rel = 'stylesheet';
    CommonCss.href = '/css/common.css';
    this.$el.appendChild(CommonCss);

    const ExamResultCss = document.createElement('link');
    ExamResultCss.rel = 'stylesheet';
    ExamResultCss.href = '/exam/css/result.css';
    this.$el.appendChild(ExamResultCss);

    this.getExamConfigCss().then((cssElement: HTMLLinkElement) => {
      this.$el.appendChild(cssElement);
    });

    const CommonJs = document.createElement('script');
    CommonJs.src = '/js/common.js';
    this.$el.appendChild(CommonJs);
  }

  /**
   * 映像ファイルか判定する
   *
   * @param filename ファイル名
   */
  // eslint-disable-next-line class-methods-use-this
  private isVideo(filename?: string) {
    if (filename === undefined) return false;
    const etx = ExamResult.getExt(filename);
    const video = ['mp4'];
    return video.includes(etx);
  }

  /**
   * 音声ファイルか判定する
   *
   * @param filename ファイル名
   */
  // eslint-disable-next-line class-methods-use-this
  private isAudio(filename?: string) {
    if (filename === undefined) return false;
    const etx = ExamResult.getExt(filename);
    const audio = ['mp3', 'm4a'];
    return audio.includes(etx);
  }

  /**
   * 拡張子を取得する
   *
   * @param filename ファイル名
   */
  static getExt(filename?: string) {
    if (filename === undefined) {
      return '';
    }
    const pos = filename.lastIndexOf('.');
    if (pos === -1) return '';
    return filename.slice(pos + 1);
  }

  /**
   * 試験画面へ遷移
   */
  private transitionToExam() {
    if (this.childTab !== null) {
      // eslint-disable-next-line no-alert
      alert('既にクイズが開始されています');
      return;
    }
    const encodeRankCode = StringUtil.encodeToBase64Url(this.resultRankCode);
    // 新しく開いたwindowオブジェクトを保持
    this.childTab = window.open(`${this.paths.EXAM}?entry=${this.entryCode}&rank=${encodeRankCode}`, `exam${Date.now()}`);
  }

  /**
   * 受験した検定ランク情報を取得し、タイトル、再受験可能フラグを設定する
   */
  private async initRankInfo() {
    const result = this.result as any;
    const RankRepository = RepositoryFactory.get().rank;
    await RankRepository.getRankInfo(StringUtil.encodeToBase64Url(result.exam_rank_code)).then((response: any) => {
      if (response.status !== 200) {
        return;
      }
      const rank = response.data;
      this.rankTitle = rank.exam_rank_title;
      const existLimit = rank.exist_limit as boolean;
      const canRetakeAfterPassing = rank.can_retake_after_passing as boolean;
      const isPass = String(result.status) === 'pass';
      const rankResources = rank.resources;

      this.setRetest(existLimit, rank, isPass, canRetakeAfterPassing);
      this.setRankResources(rankResources);
    });
  }

  /** 再受験についての設定を行う */
  setRetest(existLimit: boolean, rank: any, isPass: boolean, canRetakeAfterPassing: boolean) {
    const result = this.result as any;
    if (existLimit) {
      const examinationCount = result.examination_count;
      const isLowerLimit = rank.possible_exam_count > examinationCount;

      // 合格後再受験可で回数を満たしていない場合
      if (isPass && canRetakeAfterPassing && isLowerLimit) {
        this.isDisplayRetest = true;
        return;
      }

      // 不合格で回数を満たしていない場合
      if (!isPass && isLowerLimit) {
        this.isDisplayRetest = true;
      }
    } else {
      // 受験回数無制限で不合格の場合
      if (!isPass) {
        this.isDisplayRetest = true;
        return;
      }

      // 受験回数無制限で合格後再受験可の場合
      if (isPass && canRetakeAfterPassing) {
        this.isDisplayRetest = true;
      }
    }
  }

  /** 取得したランクのリソースを設定する */
  setRankResources(rankResources: any) {
    if (!Array.isArray(rankResources)) {
      return;
    }
    rankResources.forEach((resource: any) => {
      const key = resource.display_place_key;
      if (key in this.resources) {
        const tmp = new DesignResource();
        tmp.displayPlaceKey = resource.display_place_key;
        tmp.displayText = StringUtil.isEmpty(resource.display_text) ? '' : resource.display_text;
        tmp.cssClassName = StringUtil.isEmpty(resource.css_class_name) ? '' : resource.css_class_name;
        tmp.resourceUri = StringUtil.isEmpty(resource.resource_uri) ? '' : resource.resource_uri;
        tmp.resourceFileName = StringUtil.isEmpty(resource.resource_file_name) ? '' : resource.resource_file_name;
        tmp.alternativeText = StringUtil.isEmpty(resource.alternative_text) ? '' : resource.alternative_text;
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        this.resources[key] = tmp;
      }
      if (resource.display_place_key === DesignCode.TWITTER_SHARE_RESULT_TEXT) {
        this.twitterShareResultText = resource.display_text;
        return;
      }
      if (resource.display_place_key === DesignCode.SHOW_MODEL_ANSWERS_START) {
        if (!StringUtil.isEmpty(resource.display_text)) {
          this.isShowModelAnswers = moment(resource.display_text).isBefore(moment());
        }
      }
    });
  }

  @Watch('rankTitle')
  @Watch('result')
  @Watch('scoreLevel')
  @Watch('twitterShareResultText')
  resetShareResultText() {
    this.setShareResultText(this.twitterShareResultText);
  }

  private async setShareResultText(shareResultText: string|null) {
    if (shareResultText && !StringUtil.isEmpty(shareResultText)) {
      this.shareResultText = shareResultText;
    }
    if (!this.examInfo || !this.result || !this.rankTitle) {
      return;
    }
    const textParameters = {
      '%%exam_title%%': this.examInfo.examTitle || '',
      '%%rank_title%%': this.rankTitle || '',
      '%%score_level_name%%': this.scoreLevel.name || '',
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      '%%result_status%%': this.result.status === 'pass' ? '合格' : '不合格',
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      '%%result_correct_rate%%': String(this.result.correct_rate),
      '%%user_id%%': this.$refs.examNav.navUserId,
    };
    // eslint-disable-next-line no-restricted-syntax
    for (const [key, val] of Object.entries(textParameters)) {
      const regExp = new RegExp(key, 'g');
      this.shareResultText = this.shareResultText.replace(regExp, val);
    }
  }

  private setResultShareUri(uri?: string): boolean {
    if (uri === undefined) {
      return false;
    }
    this.resultShareUri = uri;
    return true;
  }

  @Watch('shareResultText')
  @Watch('resultShareUri')
  private setTwitterShareUri() {
    if (StringUtil.isEmpty(this.shareResultText)) {
      return;
    }
    if (!StringUtil.isEmpty(this.resultShareUri)) {
      this.twitterShareUri = `https://twitter.com/intent/tweet?text=${encodeURIComponent(this.shareResultText)}&url=${encodeURIComponent(this.designPathCreate(this.resultShareUri))}`;
      return;
    }
    this.twitterShareUri = `https://twitter.com/intent/tweet?text=${encodeURIComponent(this.shareResultText)}`;
  }
}
